import React from 'react';

import { Col } from 'react-bootstrap';

type Props = {
    message: JSX.Element | string;
    renderTooltip?: () => JSX.Element | null;
};
const Header = ({ message, renderTooltip }: Props) => (
    <Col xs={12}>
        <div className="iwoca-form-section-header">
            <h4>
                {message}
                {renderTooltip ? renderTooltip() : null}
            </h4>
        </div>
    </Col>
);

export default Header;
